/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
//eslint-disable-next-line no-useless-constructor
import { Injectable } from "@angular/core";
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpResponse,
	HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { SweetAlertService } from "src/app/services/shared-service/sweetalert/sweet-alert.service";
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(
		private authService: AuthService,
		private router: Router,
		private sweetalertService: SweetAlertService
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		// Add the JWT token to the request headers
		const token = localStorage.getItem("token");
		if (token) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
				},
        // withCredentials:true
			});
		} else {
			if (!(request.url.includes("/login") || request.url.includes("client/password"))) {
				this.sweetalertService
					.showTitleErorIcon("Session Expired")
					.then((val) => {
						this.router.navigate(["/authentication/signin"]);
					});
			}
		}
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				// 401 indicates access tokn is expired
				//so we try to access /refreshtoken endpoint
				if (error.status === 401) {
					// If a refresh token is already in progress, wait for it to complete before retrying
					if (this.authService.isRefreshingToken()) {
						return this.authService.renewRefreshToken("token").pipe(
							switchMap(() => {
								return next.handle(this.addToken(request));
							})
						);
					}

					// Otherwise, initiate a refresh token request
					return this.authService.renewRefreshToken("").pipe(
						switchMap((token) => {
							localStorage.setItem("token", token.refreshToken);
							return next.handle(this.addToken(request));
						}),
						catchError((refreshError) => {
							// this.authService.logout();
							console.log("logout");
							return throwError(() => refreshError);
						})
					);
				} else if (error.status === 403 && !request.url.includes("/sigin")) {
					localStorage.clear();
					this.sweetalertService
						.showTitleErorIcon("Session Expired")
						.then((val) => {
							this.router.navigate(["/authentication/signin"]);
						});
				} else {
					return throwError(() => 'Unable to process');
				}
			})
		);
	}

	private addToken(request: HttpRequest<any>) {
		const token = localStorage.getItem("token");
		if (token) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
				},
        // withCredentials:true
			});
		}
		return request;
	}
}
